import { format } from 'date-fns';
import I18n from 'i18n-js';
import { func, object, string } from 'prop-types';

import { getDateFormatUnicode } from '@lootboy/lib/utils/dateAndTime';

import Code from './Code';
import Scratch from './Scratch';
import UriButton from './UriButton';

import styles from './RewardCodeView.module.scss';

function RewardCodeView({ card, country, onOpened }) {
  const { cardTemplate, reward } = card;
  const rewardCode = reward?.code;
  const uri = reward?.uri;
  const uriCode = cardTemplate?.isUriCode;

  return (
    <div className={styles.rewardCodeView}>
      {cardTemplate && cardTemplate.availableUntil && (
        <p>
          {I18n.t('RewardCodeView_available_until_label', {
            date: format(
              new Date(cardTemplate.availableUntil),
              getDateFormatUnicode(country),
            ),
          })}
        </p>
      )}
      {rewardCode && !uriCode && (
        <Code
          cardTemplate={cardTemplate}
          rewardCode={rewardCode}
        />
      )}
      {(uri || (rewardCode && uriCode)) && (
        <UriButton
          cardTemplate={cardTemplate}
          country={country}
          reward={reward}
          uriCode={uriCode}
        />
      )}
      {!rewardCode && !uri && <Scratch onOpened={onOpened} />}
    </div>
  );
}

RewardCodeView.propTypes = {
  card: object,
  country: string,
  onOpened: func,
};

export default RewardCodeView;
